import type { AssessmentTest } from '@entities/assessment'

import { questions } from '../questions/math/grade-k9'

export const configK9: AssessmentTest = {
  title: 'Grade 9 math assessment',
  quizTitle: 'Math assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  questions: questions,
}
